import { Icon } from '@iconify/react';
import { Card, CardHeader, CardBody, Checkbox, Divider } from '@heroui/react';
import Compressor from 'compressorjs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function Camera({ questionId, sendAnswer, answerHistory }) {
  const { t } = useTranslation('survey');
  const [imageURL, createImageURL] = useState('');

  const previewSavedImage = (file) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      createImageURL(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const [skipped, setSkipped] = useState(false);

  useEffect(() => {
    if (answerHistory !== undefined) {
      if (answerHistory.type) {
        previewSavedImage(answerHistory);
        setSkipped(false);
      } else {
        setSkipped(true);
      }
    }
  }, [questionId, answerHistory]);

  const handleInputChange = () => {
    setSkipped(true);
    createImageURL('');
    sendAnswer(false);
  };

  const handleImageChange = async (e) => {
    setSkipped(false);
    const file = e.target.files[0];

    if (!file) {
      return;
    }

    new Compressor(file, {
      quality: 0.6,
      success(result) {
        sendAnswer(result);
        previewSavedImage(result);
      },
      error(err) {
        console.log(err.message);
      },
    });
  };

  return (
    <>
      <Card>
        <CardHeader className="flex flex-col gap-4">
          <div className="flex flex-col items-center">
            <Icon icon="mdi:file-upload" className="text-6xl" />
            <span className="text-xl font-semibold">
              {t('camerainput.button.gallery')}
            </span>
          </div>
          <div>
            <input
              id="upload"
              type="file"
              accept="image/jpeg,image/png"
              onChange={(e) => handleImageChange(e)}
              style={{ paddingLeft: '64px' }}
            />
          </div>
        </CardHeader>
        <Divider />
        <CardBody className="items-center">
          <Checkbox
            isSelected={skipped}
            radius="full"
            onChange={handleInputChange}
          >
            {t('camerainput.button.skip')}
          </Checkbox>
        </CardBody>
      </Card>
      {imageURL && (
        <div className="m-4 place-self-center w-1/2">
          <img src={imageURL} alt={t('common.text.attachment')} />
        </div>
      )}
    </>
  );
}
